import localDB from "./localDB";
let GLOBAL = require('./globals');

const DynamicTableData = {
    async list(url, search, page) {
        let search_fields = `search=${search}`
        if(typeof search !== 'string'){
            search_fields = Object.entries(search).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
        }
        let response = await fetch(`${GLOBAL.BASE_URL}api/${url}?${search_fields}&page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default DynamicTableData;


// WEBPACK FOOTER //
// ./src/data/DynamicTableData.js